/* Dunavski Plamen: small storefront polish (dp-design.js)
   1. Product names "IME – opis" are shown as the name, with the
      description on its own line in small italic. The product title
      itself is untouched (search, Google and SEO keep the full text).
   2. English labels that Shopify injects (sorting, filters, country
      names) are shown in Serbian.
   Runs on load and whenever the theme swaps content in (filters,
   recommendations, cart drawer, predictive search). */
(function () {
  var SEP = /\s+[–—-]\s+/;
  var TITLE_SEL = [
    '.card__heading a', '.card__heading:not(:has(a))',
    '.cart-item__name', '.cart-notification-product__name',
    '.predictive-search__item-heading', '.dp-upsell__name'
  ].join(',');

  function splitTitle(el) {
    if (!el || el.dataset.dpSplit) return;
    if (el.children.length && !(el.children.length === 1 && el.firstElementChild.tagName === 'SPAN' && !el.firstElementChild.className)) return;
    var text = el.textContent.trim();
    var parts = text.split(SEP);
    el.dataset.dpSplit = '1';
    if (parts.length < 2) return;
    var name = parts.shift();
    var sub = parts.join(' ');
    el.textContent = '';
    var n = document.createElement('span'); n.className = 'dp-name'; n.textContent = name;
    var s = document.createElement('span'); s.className = 'dp-sub'; s.textContent = sub;
    el.appendChild(n); el.appendChild(s);
    if (!el.getAttribute('aria-label') && el.tagName === 'A') el.setAttribute('aria-label', name + ', ' + sub);
  }

  var WORDS = {
    'Availability': 'Dostupnost',
    'Price': 'Cena',
    'In stock': 'Dostupno',
    'Out of stock': 'Nije dostupno',
    'Featured': 'Izdvojeno',
    'Best selling': 'Najprodavanije',
    'Most relevant': 'Najrelevantnije',
    'Relevance': 'Najrelevantnije',
    'Alphabetically, A-Z': 'Po nazivu, od A do Ž',
    'Alphabetically, Z-A': 'Po nazivu, od Ž do A',
    'Price, low to high': 'Cena, od najniže',
    'Price, high to low': 'Cena, od najviše',
    'Date, old to new': 'Najstarije prvo',
    'Date, new to old': 'Najnovije prvo',
    'Serbia': 'Srbija',
    'Bosnia & Herzegovina': 'Bosna i Hercegovina',
    'Montenegro': 'Crna Gora',
    'Croatia': 'Hrvatska',
    'Provjereno': 'Potvrđena kupovina',
    'Temeljeno na': 'Na osnovu'
  };
  var KEYS = Object.keys(WORDS).sort(function (a, b) { return b.length - a.length; });

  function translateNode(node) {
    var t = node.nodeValue;
    if (!t || !/[A-Za-z]/.test(t)) return;
    var out = t;
    for (var i = 0; i < KEYS.length; i++) {
      if (out.indexOf(KEYS[i]) !== -1) out = out.split(KEYS[i]).join(WORDS[KEYS[i]]);
    }
    out = out.replace(/\bRSD\s+РСД\b/g, 'RSD');
    if (out !== t) node.nodeValue = out;
  }

  function translateIn(root) {
    var scope = root.querySelectorAll ? root.querySelectorAll(
      '.facets, .facet-filters, .mobile-facets, .active-facets, .localization-form, .disclosure, .jdgm-widget, .dpf'
    ) : [];
    var nodes = [];
    for (var i = 0; i < scope.length; i++) {
      var w = document.createTreeWalker(scope[i], NodeFilter.SHOW_TEXT, null);
      var n; while ((n = w.nextNode())) nodes.push(n);
      var opts = scope[i].querySelectorAll('option');
      for (var j = 0; j < opts.length; j++) {
        var v = opts[j].textContent.trim();
        if (WORDS[v]) opts[j].textContent = WORDS[v];
      }
    }
    nodes.forEach(translateNode);
  }

  function run(root) {
    root = root || document;
    var els = root.querySelectorAll ? root.querySelectorAll(TITLE_SEL) : [];
    for (var i = 0; i < els.length; i++) splitTitle(els[i]);
    translateIn(root.nodeType === 1 ? (root.parentElement || root) : document);
  }

  var queued = false;
  var obs = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; obs.disconnect(); run(document); start(); });
  });
  function start() { obs.observe(document.body, { childList: true, subtree: true }); }

  function init() { run(document); start(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
